import HttpClienteToken from '../../services/HttpClientToken';

import { ZonaProps } from '../../interfaces/catalogos/ZonaInterface';

export const Zonas = () => {

    return new Promise<ZonaProps[]>( (resolve, eject) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClienteToken.get('/Api/Zona/', token)
            .then( ({ data } : { data : ZonaProps[] } ) => {               
                resolve( data );                
            })
            .catch( () => {
                resolve( [] );
            });
        }

    });

}

export const ObtenerZona = () => {

    return new Promise<ZonaProps[]>( (resolve, eject) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClienteToken.get('/Api/Zona/ObtenerZonas', token)
            .then( ({ data } : { data : ZonaProps[] } ) => {               
                resolve( data );                
            })
            .catch( () => {
                resolve( [] );
            });
        }

    });

}

export const ActualizarZona = ( params: ZonaProps ) => {

    return new Promise<ZonaProps>( (resolve, eject) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){
            const { token } = data;

            HttpClienteToken.post('/Api/Zona/Actualizar', params, token)
            .then( ({ data } : { data : ZonaProps} ) => {               
                resolve( data );                
            })
            .catch( () => {
                resolve( {
                    idZona: 0,
                    descripcion: '',
                    activo: false,  
                });
            });
        }

    });

}

export const AgregarZona = ( params: ZonaProps ) => {

    return new Promise<ZonaProps>( (resolve, eject) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){
            const { token } = data;

            HttpClienteToken.post('/Api/Zona/Agregar', params, token)
            .then( ({ data } : { data : ZonaProps} ) => {               
                resolve( data );                
            })
            .catch( () => {
                resolve( {
                    idZona: 0,
                    descripcion: '',
                    activo: false,   
                });
            });
        }

    });

}